
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import DataTable from "examples/Tables/DataTable";
import Loading from "components/Loading";
import { useState, useEffect } from "react";
import apiClient from "Api"
import PropTypes from "prop-types";
import { useSnackbar } from 'notistack';
import Icon from "@mui/material/Icon";
import Chip from "@mui/material/Chip";
import MDButton from "components/MDButton";
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import MDInput from "components/MDInput";
import ConfirmDialog from "components/ConfirmDialog";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

function TenantUsers({ tenantId }) {

    const [isLoading, setIsLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [open, setOpen] = useState(false);

    const [confirmResendEmailDialog, setConfirmResendEmailDialog] = useState(false);
    const [confirmResendEmail, setConfirmResendEmail] = useState("");

    const [confirmDeleteUserDialog, setConfirmDeleteUserDialog] = useState(false);
    const [confirmDeleteUser, setConfirmDeleteUser] = useState(null);

    const [columns, setColumns] = useState([
        { Header: "E-mail", accessor: "email", width: "30%", align: "left" },
        { Header: "Confirmado?", accessor: "confirmed", align: "left" },
        { Header: "Ações", accessor: "actions", align: "left" }
    ]);
    const [rows, setRows] = useState([]);

    const [tableData, setTableData] = useState({ columns: columns, rows: rows, pageCount: rows.length, pageChangeHandle: getTenantUsers });

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    function resendConfirmationEmail(email) {
        if (email !== "" && email !== undefined) {
            setIsLoading(true);
            apiClient.post(`/account/resendconfirmationemail/${tenantId}`, { email: email })
                .then(response => {
                    setIsLoading(false);
                    enqueueSnackbar(`E-mail de confirmação enviado!`, { variant: "success" });
                }).catch(e => {
                    setIsLoading(false);
                    enqueueSnackbar(`Erro ao re-enviar e-mail de confirmação!`, { variant: "error" });
                });
        }
        else {
            enqueueSnackbar(`E-mail inválido!`, { variant: "error" });
        }
    }

    function deleteUser(user) {
        if (user !== undefined && user !== null) {
            setIsLoading(true);
            apiClient.delete(`/account/deletetenantuser/${user.tenantId}/${user.id}`)
                .then(response => {
                    setIsLoading(false);
                    enqueueSnackbar(`Usuário removido!`, { variant: "success" });
                    getTenantUsers();
                }).catch(e => {
                    setIsLoading(false);
                    enqueueSnackbar(`Erro ao remover usuário!`, { variant: "error" });
                });
        }
        else {
            enqueueSnackbar(`Usuário inválido!`, { variant: "error" });
        }
    }

    function saveUser(email) {
        if (email !== "" && email !== undefined) {
            setIsLoading(true);
            apiClient.post(`/account/registertenantuser/${tenantId}`, { email: email, tenantId: tenantId })
                .then(response => {
                    setIsLoading(false);
                    enqueueSnackbar(`Usuário adcionado! Foi enviado um e-mail para confirmação de conta e cadastro de senha.`, { variant: "success" });
                    getTenantUsers();
                }).catch(e => {
                    setIsLoading(false);

                    let errorDetail = "";
                    if (e?.response?.data?.errors["DuplicateUserName"] !== undefined) {
                        errorDetail += "E-mail informado já cadastrado!"
                    }

                    enqueueSnackbar(`Erro ao adicionar usuário! ${errorDetail}`, { variant: "error" });
                });
        }
        else {
            enqueueSnackbar(`E-mail inválido!`, { variant: "error" });
        }
    }

    function getTenantUsers() {
        setIsLoading(true);

        apiClient.get(`/account/tenantusers/${tenantId}`)
            .then(reponse => {
                let rowsPage = [];
                reponse.data.map((item) => {
                    rowsPage.push({
                        email: (
                            <MDTypography variant="caption" color="text" fontWeight="medium" key={item.id} >
                                {item.email}
                            </MDTypography>),
                        confirmed: (
                            <MDTypography component="a" href="#" variant="button" color="text" fontWeight="medium">
                                {item.emailConfirmed && <Chip label="Confirmado" color="info" variant="outlined" />}
                                {!item.emailConfirmed && <Chip label="Pendente" color="warning" variant="outlined" />}
                            </MDTypography>
                        ),
                        actions: (
                            <>
                                <Tooltip title="Remover usuário">
                                    <IconButton onClick={() => { setConfirmDeleteUser(item); setConfirmDeleteUserDialog(true); }}
                                        color="info" tooltip="teste"><Icon color="error" sx={{ fontSize: "large" }}>delete_forever_icon </Icon></IconButton>
                                </Tooltip>

                                {!item.emailConfirmed && <Tooltip title="Reenviar e-mail de confirmação de conta">
                                    <IconButton onClick={() => { setConfirmResendEmail(item.email); setConfirmResendEmailDialog(true); }}
                                        color="info" tooltip="teste"><Icon sx={{ fontSize: "large" }}>mark_email_read_icon</Icon></IconButton>
                                </Tooltip>}
                            </>
                        ),
                    })
                });

                setRows(rowsPage);
                setTableData({ columns: columns, rows: rowsPage, pageCount: reponse.data.length, pageChangeHandle: getTenantUsers });
                setIsLoading(false);
            }).catch(e => {
                setIsLoading(false);
                enqueueSnackbar(`Erro ao retornar usuários!`, { variant: "error" });
            });
    }

    useEffect(() => {
        getTenantUsers();
    }, []);

    return (<MDBox pt={3} pb={4}>
        <Grid container spacing={6}>
            <Grid item xs={12}>
                <Card sx={{ position: "relative" }}>
                    <MDBox pt={2} >
                        <Loading isLoading={isLoading}></Loading>
                        <DataTable
                            table={tableData}
                            isSorted={true}
                            entriesPerPage={false}
                            showTotalEntries={false}
                            canSearch={false}
                            noEndBorder
                        />
                    </MDBox>
                    <Fab sx={{ position: "absolute", right: "16px", bottom: "16px" }} size="medium" color="info" aria-label="add" onClick={handleClickOpen}>
                        <AddIcon />
                    </Fab>
                </Card>
            </Grid>
        </Grid>
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="md"
            fullWidth={true}
            PaperProps={{
                component: 'form',
                onSubmit: (event) => {
                    event.preventDefault();
                    const formData = new FormData(event.currentTarget);
                    const formJson = Object.fromEntries(formData.entries());
                    saveUser(formJson.email);
                    handleClose();
                },
            }}
        >
            <DialogTitle>Adicionar usuário</DialogTitle>
            <DialogContent>
                <Grid container p={1}>
                    <Grid item xs={12} sm={12}>
                        <MDInput autoFocus type="email" label="E-mail" name="email" fullWidth required />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <MDButton onClick={handleClose}>Cancelar</MDButton>
                <MDButton type="submit" color="info" variant="contained">Salvar</MDButton>
            </DialogActions>
        </Dialog>

        <ConfirmDialog
            title="Reenvio do e-mail de confirmação?"
            open={confirmResendEmailDialog}
            setOpen={setConfirmResendEmailDialog}
            onConfirm={() => { resendConfirmationEmail(confirmResendEmail) }}
        >
            Tem certeza que deseja reenviar o e-mail de confirmação para o usuário {confirmResendEmail}
        </ConfirmDialog>

        {confirmDeleteUser && <ConfirmDialog
            title="Remover usuário?"
            open={confirmDeleteUserDialog}
            setOpen={setConfirmDeleteUserDialog}
            onConfirm={() => { deleteUser(confirmDeleteUser) }}
        >
            Tem certeza que deseja remover o usuário {confirmDeleteUser.email}
        </ConfirmDialog>}
    </MDBox >
    );
}

TenantUsers.propTypes = {
    tenantId: PropTypes.string
};

export default TenantUsers;
